<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        edit-mode
        @backBtnClicked="redirectToOverview"
    >
        <kgr-member-dog-relations-data-provider
            v-slot="relationsScope"
            :member-id="memberId"
            :callback="onRelationsLoaded"
        >
            <div class="animated fadeIn">
                <h1 class="kgr-headline kgr-headline--h2 kgr-headline--text kgr-headline--firstInText">
                    {{ $t('Zugehörige Hunde') }}
                </h1>
                <kgr-member-dog-relations-form
                    :club-id="clubId"
                    :relations="relationsScope.data"
                    :error="error"
                    :pending-create="pendingRelationCreate"
                    @addRelation="onAdd($event, relationsScope.reload)"
                />
                <kgr-member-dog-relation-list
                    :relations="ownerRelations"
                    :pending-remove="pendingRelationRemove"
                    :is-deletable="true"
                    :headline="$t('club.dog.memberRelation.association.owner')"
                    @remove="onRemove($event, relationsScope.reload)"
                />
                <kgr-member-dog-relation-list
                    :relations="handlerRelations"
                    :pending-remove="pendingRelationRemove"
                    :is-deletable="true"
                    :headline="$t('club.dog.memberRelation.association.handler')"
                    @remove="onRemove($event, relationsScope.reload)"
                />
            </div>
        </kgr-member-dog-relations-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import Error from '../../js/model/Error.js';
import FormScaffold from '../../components/common/form/FormScaffold.vue';
import MemberDogRelationList from '../../components/members/MemberDogRelationList.vue';
import MemberDogRelationsDataProvider from '../../components/data-provider/MemberDogRelationsDataProvider.vue';
import MemberDogRelationsForm from '../../components/members/MemberDogRelationsForm.vue';
import MemberRepository from '../../js/repository/MemberRepository.js';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-member-dog-relations-data-provider': MemberDogRelationsDataProvider,
        'kgr-member-dog-relations-form': MemberDogRelationsForm,
        'kgr-member-dog-relation-list': MemberDogRelationList,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true
        },
        memberId: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pendingRelationCreate: false,
            pendingRelationRemove: false,
            error: new Error(),
            relations: []
        };
    },
    computed: {
        ownerRelations() {
            return this.relations.filter(r => r.association === 'owner');
        },
        handlerRelations() {
            return this.relations.filter(r => r.association === 'handler');
        }
    },
    watch: {
    },
    created() {
    },
    methods: {
        onRelationsLoaded(relations) {
            this.relations = relations;
        },
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onAdd(relation, reload) {
            this.error = new Error();
            this.pendingRelationCreate = true;

            MemberRepository.addDogRelation(this.clubId, this.memberId, relation)
                .then(() => {
                    this.pendingRelationCreate = false;
                    this.$notify.success('Der Hund wurde erfolgreich hinzugefügt');
                    reload();
                })
                .catch(error => {
                    this.error = error;
                    this.pendingRelationCreate = false;
                    this.$notify.error('saveChanges.error');
                });
        },
        onRemove(relation, reload) {
            this.pendingRelationRemove = true;

            MemberRepository.removeDogRelation(this.memberId, relation.id)
                .then(() => {
                    this.pendingRelationRemove = false;
                    this.$notify.success('Hund erfoglreich entfernt');
                    reload();
                })
                .catch(error => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pendingRelationRemove = false;
                });
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
